import React from 'react';

import type { CustomCellRendererProps } from 'ag-grid-react';
import ContextMenu, { IContextMenuOption } from "../../../components/ContextMenu/ContextMenu";
import { toast } from "../../../components/Toast/ToastManager";

import styles from "./BulkDiscountCodesTab.module.scss";

interface ActionsRendererProps extends CustomCellRendererProps {
  refreshData: () => void;
}

export const ActionsRenderer = (props: ActionsRendererProps) => {
  const data = props.data;
  
  const menuOptions: IContextMenuOption[] = [
    {
      label: "Copy Code",
      onClick: () => {
        navigator.clipboard.writeText(data.code);
        toast.show({
          title: "Copied",
          content: `Code "${data.code}" copied to clipboard`,
          duration: 3000,
          type: "success"
        });
      }
    },
    {
      label: "View Details",
      onClick: () => {
        // TODO: Implement view details functionality
        toast.show({
          title: "Details",
          content: `Batch: ${data.batch_name}\nCode: ${data.code}\nStatus: ${data.status}`,
          duration: 5000,
          type: "info"
        });
      }
    }
  ];

  // Add expire option for active codes
  if (data.status === "active") {
    menuOptions.push({
      label: "Expire Code",
      onClick: () => {
        // TODO: Implement expire functionality
        toast.show({
          title: "Expire Code",
          content: "Expire functionality coming soon",
          duration: 3000,
          type: "info"
        });
      }
    });
  }

  return (
    <div className={styles.ActionRenderer}>
      <ContextMenu
        label=""
        options={menuOptions}
      />
    </div>
  );
}; 